module.exports = __webpack_public_path__ + "static/img/homebanner2.9056958.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/homebanner2.png
// module id = KSyH
// module chunks = 2